/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/container/css/definition/content/container.css */
@layer container.definition.content.container {
  :host {
    display: block;
    max-width: 100%;
  }
  @media only screen and (max-width: 767px) {
    :host {
      width: auto;
      margin-left: 1em;
      margin-right: 1em;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    :host {
      width: 723px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    :host {
      width: 933px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media only screen and (min-width: 1200px) {
    :host {
      width: 1127px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media only screen and (min-width: 1980px) {
    :host {
      width: 1376px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  :host.text {
    max-width: 700px;
    line-height: 1.5;
  }
  :host.fluid {
    width: 100%;
  }
}

/* src/primitives/container/css/definition/variations/aligned.css */
@layer container.definition.variations.aligned;

/* src/primitives/container/css/definition/container-definition.css */

/* src/primitives/container/css/theme/content/container-variables.css */
@layer container.theme.content.container {
  :host {
  }
}

/* src/primitives/container/css/theme/variations/aligned-variables.css */
@layer container.theme.variations.aligned {
  :host {
  }
}

/* src/primitives/container/css/theme/container-theme.css */

/* src/primitives/container/css/container.css */
